<route>
{
    "name": "inspections-index",
    "meta": {
        "title": "Inspectii tehnice",
        "requiresAuth": true,
        "permissions": ["manager", "sef_de_unitate", "birou", "service"],
        "fail": "/404"
    }
}
</route>
<template>
  <company-layout>
      <v-container fluid grid-list-xl>
          <v-row>
              <v-col>
                  <index></index>
              </v-col>
          </v-row>
      </v-container>
  </company-layout>
</template>

<script>
import CompanyLayout from "Layouts/Company.vue";
import Index from 'Components/inspections/Index'

export default {
    components: {
        CompanyLayout,
        Index
    }
};
</script>
